import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Users, DollarSign, Activity, Flame, AlertTriangle, Trophy, ClipboardList, Smartphone } from "lucide-react";

export default function AdminDashboard() {
  const [k, setK] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    api.get("/admin/kpis")
      .then(r => setK(r.data))
      .catch(e => setErr(e.response?.data?.detail || e.message || "Failed to load KPIs"));
  }, []);
  if (err) return <div className="text-red-400 font-mono-jp text-xs uppercase tracking-widest" data-testid="admin-overview-error">⚠ {err}</div>;
  if (!k) return <div className="text-[#888]">Loading...</div>;
  return (
    <div data-testid="admin-overview">
      <div className="font-mono-jp text-[10px] uppercase tracking-widest text-[#d7ff00]">OVERVIEW</div>
      <h1 className="font-display text-4xl sm:text-5xl uppercase">Coach JP <span className="text-[#d7ff00]">command center</span></h1>

      {/* Top hero KPI — plan adoption */}
      <div className="mt-6 bg-[#0a0a0a] border border-[#1f1f1f] border-l-4 border-l-[#d7ff00] p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-6" data-testid="adoption-tile">
        <div className="relative w-24 h-24 sm:w-28 sm:h-28 flex-shrink-0">
          <svg viewBox="0 0 100 100" className="w-full h-full -rotate-90">
            <circle cx="50" cy="50" r="44" stroke="#222" strokeWidth="6" fill="none" />
            <circle cx="50" cy="50" r="44" stroke="#d7ff00" strokeWidth="6" fill="none"
              strokeDasharray={`${(k.adoption_pct / 100) * 276} 276`} strokeLinecap="round" />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <div className="font-mono-jp text-2xl text-[#d7ff00] tick">{k.adoption_pct}%</div>
            <div className="font-mono-jp text-[8px] uppercase tracking-widest text-[#888]">ADOPTION</div>
          </div>
        </div>
        <div className="flex-1">
          <div className="font-mono-jp text-[10px] uppercase tracking-widest text-[#d7ff00] flex items-center gap-2"><ClipboardList className="w-3 h-3" /> ATHLETES ON A PLAN</div>
          <div className="mt-1 font-display text-4xl sm:text-5xl uppercase tick">
            <span className="text-[#d7ff00]">{k.athletes_on_plan}</span>
            <span className="text-[#666] text-2xl sm:text-3xl"> / {k.active_athletes}</span>
          </div>
          <p className="mt-1 text-xs text-[#888]">
            {k.athletes_on_plan === 0
              ? "No athletes assigned yet. Open Programs → Assign to get them training."
              : k.adoption_pct >= 80
                ? "Strong plan adoption — keep the dynamic adjustments coming."
                : "Room to grow — review unassigned athletes in the Athletes tab."}
          </p>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-px bg-[#1f1f1f]">
        <K label="ACTIVE ATHLETES" value={k.active_athletes} icon={Users} />
        <K label="PAYING" value={k.paying_athletes} icon={DollarSign} />
        <K label="SESSIONS LOGGED" value={k.sessions_completed} icon={Activity} />
        <K label="MONTHLY REV" value={`RM ${k.monthly_revenue}`} icon={DollarSign} />
        <K label="COMPLIANCE" value={`${k.compliance_pct}%`} icon={Trophy} />
        <K label="RETENTION" value={`${k.retention_pct}%`} icon={Flame} />
        <K label="APP INSTALLS" value={k.installs ?? 0} icon={Smartphone} />
        <K label="FATIGUE ALERTS" value={k.fatigue_alerts} icon={AlertTriangle} danger />
      </div>

      <p className="mt-6 text-xs text-[#888] font-mono-jp uppercase tracking-widest">Use the tabs above to manage athletes, build programs, and broadcast messages.</p>
    </div>
  );
}

function K({ label, value, icon: Icon, danger }) {
  return (
    <div className="bg-[#0a0a0a] p-5">
      <div className="font-mono-jp text-[10px] uppercase tracking-widest text-[#888] flex items-center gap-2">
        <Icon className={`w-3 h-3 ${danger ? "text-[#ff3b30]" : "text-[#d7ff00]"}`} /> {label}
      </div>
      <div className={`mt-2 font-mono-jp text-3xl tick ${danger ? "text-[#ff3b30]" : "text-[#d7ff00]"}`}>{value}</div>
    </div>
  );
}
